import { render, staticRenderFns } from "./BbmUpload.vue?vue&type=template&id=828aa9e0&scoped=true"
import script from "./BbmUpload.vue?vue&type=script&lang=js"
export * from "./BbmUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "828aa9e0",
  null
  
)

export default component.exports